import { render, staticRenderFns } from "./default-header-loader.vue?vue&type=template&id=60fe72b0"
import script from "./default-header-loader.vue?vue&type=script&lang=js"
export * from "./default-header-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports